import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.js';
import 'font-awesome/css/font-awesome.min.css';
import Config from './commons/config/Config.js';

function renderApp(locale, messages) {
    ReactDOM.render(<App locale={locale} messages={messages} />, document.getElementById("root"));
}

function bootstrapApp(configData) {
    localStorage.setItem('config', JSON.stringify(configData));
    var defaultLocale = Config.get('defaultLanguage') || 'es';
    var locale = localStorage.getItem('userLocale') || defaultLocale;
    localStorage.setItem('userLocale', locale);

    fetch('https://flow.vecfleet.io/api/lang/' + locale, {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    })
    .then(function(response) { return response.json(); })
    .then(function(data) { renderApp(locale, JSON.parse(JSON.stringify(data))); })
    .catch(function() { renderApp(locale, {}); });
}

// Azure SSO from the mobile app authorizes with this site's Web redirect URI and marks the
// state with "app_" (see /auth/azure/redirect-app). Hand the code back to the app through its
// deep link. Runs before the auth check because /auth/azure/callback is only routed when no
// web session exists, and the app's in-app browser shares cookies/storage with the device browser.
function bounceAzureCallbackToApp() {
    var params = new URLSearchParams(window.location.search);
    var state = params.get('state') || '';
    if (window.location.pathname !== '/auth/azure/callback' || state.indexOf('app_') !== 0) {
        return false;
    }

    var target = 'vecfleet://auth/azure-callback' + window.location.search;
    window.location.replace(target);

    // Fallback when the browser asks before opening the app (e.g. iOS) or blocks the jump
    var link = document.createElement('a');
    link.href = target;
    link.textContent = 'Volver a la app VEC Fleet+';
    link.style.cssText = 'display:block;text-align:center;margin-top:40vh;font:18px sans-serif';
    document.getElementById('root').appendChild(link);
    return true;
}

if (!bounceAzureCallbackToApp()) {
    fetch('/config/config.json', {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    })
    .then(function(response) { return response.json(); })
    .then(function(configData) { bootstrapApp(configData); })
    .catch(function() {
        try {
            var cached = JSON.parse(localStorage.getItem('config'));
            if (cached) { bootstrapApp(cached); return; }
        } catch(e) {}
        renderApp('es', {});
    });
}
